module.exports = __webpack_public_path__ + "img/F_c icon128x128.d6a5291c.png";